/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch} from 'react-redux'
import useUtils from './useUtils'
import {setTitle} from '../../redux/reducers/mainSlice'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import {useNavigate} from 'react-router-dom'

const ListView = ({
  subscriptions,
  setSubscriptions,
  limit,
  page,
  setLoading,
  pricing,
  selectedCurrency,
  className,
}) => {
  const dispatch = useDispatch()
  dispatch(setTitle('Subscription'))
  const {handleDelete} = useUtils()
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const navigate = useNavigate()

  const handleEdit = (values) => {
    navigate('/subscriptionlist/editSubscription', {state: {values}})
  }

  const onDelete = (id, state) => {
    setSelectedId(id)
    setSelectedState(state)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await handleDelete(selectedId, selectedState, limit, (page - 1) * limit)
      setSubscriptions(result)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  return (
    <>
      <div className={`${className}`}>
        <div className={`card ${className}`}>
          <div className='card-body py-10'>
            <div className='table-responsive'>
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='w-350px'>ID</th>
                    <th className='w-200px'>Name</th>
                    <th className='w-200px'>Price</th>
                    <th className='text-end '>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {subscriptions?.records &&
                    subscriptions?.records?.map((value, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className='text-dark fw-bold  fs-6'>
                              {value.id}
                            </span>
                          </td>

                          <td>
                            <a href='#' className='text-dark fw-bold  fs-6'>
                              {value.name}
                            </a>
                          </td>

                          <td>
                            <a href='#' className='text-dark fw-bold  fs-6'>
                              {pricing === 'Monthly' && <>{` $ ${value?.monthlyPrice}`}</>}

                              {pricing === 'Yearly' && <>{` $ ${value?.yearlyPrice}`}</>}
                            </a>
                          </td>

                          <td className='d-flex justify-content-end'>
                            <a
                              onClick={() => {
                                handleEdit(value)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                              <KTSVG
                                path='/media/icons/duotune/art/art005.svg'
                                className='svg-icon-3 svg-icon-primary'
                              />
                            </a>
                            <a
                              onClick={() => onDelete(value?.id, !value?.isActive)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen040.svg'
                                className={`svg-icon-3 ${
                                  value?.isActive ? 'svg-icon-danger' : 'svg-icon-success'
                                }`}
                              />
                            </a>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmation
        isVisible={modalVisible}
        message={
          !selectedState
            ? 'Are you sure you want to deactivate this Subscription ?'
            : 'Are you sure you want to activate this Subscription?'
        }
        onConfirm={confirmDelete}
        onCancel={() => setModalVisible(false)}
      />
    </>
  )
}
export default ListView
